<template>
  <Teleport to="body">
    <div v-if="balanceTipSheet" class="bet-feedback-mask">
      <div class="bet-feedback-panel">
        <div class="bet-feedback-body">
          <span class="bet-feedback-icon fail" aria-hidden="true">i</span>
          <p>您的余额不足</p>
        </div>
        <button type="button" class="bet-feedback-ok" @click="closeBalanceTip">
          确认 ({{ balanceTipCountdown }})
        </button>
      </div>
    </div>

    <div v-if="betSuccessSheet" class="bet-feedback-mask">
      <div class="bet-feedback-panel">
        <div class="bet-feedback-body">
          <span class="bet-feedback-icon success" aria-hidden="true">
            <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
              <path
                fill="currentColor"
                d="M79.9,40C79.9,62,62,79.9,40,79.9S0.1,62,0.1,40S18,0.1,40,0.1S79.9,18,79.9,40z M40,4.1C20.2,4.1,4.1,20.2,4.1,40S20.2,75.9,40,75.9S75.9,59.8,75.9,40S59.8,4.1,40,4.1z"
              />
              <path
                fill="currentColor"
                d="M33.9,54.4L20.6,41c-0.6-0.6-0.6-1.5,0-2.1l0.7-0.7c0.6-0.6,1.5-0.6,2.1,0l13.4,13.4c0.6,0.6,0.6,1.5,0,2.1L36,54.5C35.5,55,34.5,55,33.9,54.4z"
              />
              <path
                fill="currentColor"
                d="M59.9,28.3L36.2,54.4c-0.6,0.6-1.5,0.7-2.1,0.1l-0.7-0.7c-0.6-0.6-0.7-1.5-0.1-2.1l23.7-26.1c0.6-0.6,1.5-0.7,2.1-0.1l0.7,0.7C60.4,26.7,60.4,27.6,59.9,28.3z"
              />
            </svg>
          </span>
          <p>购买成功</p>
        </div>
        <button type="button" class="bet-feedback-ok" @click="closeBetSuccessTip">
          确认 ({{ betSuccessCountdown }})
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
defineProps({
  balanceTipSheet: { type: Boolean, default: false },
  balanceTipCountdown: { type: Number, default: 4 },
  closeBalanceTip: { type: Function, required: true },
  betSuccessSheet: { type: Boolean, default: false },
  betSuccessCountdown: { type: Number, default: 3 },
  closeBetSuccessTip: { type: Function, required: true }
})
</script>

<style scoped>
.bet-feedback-mask {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}
.bet-feedback-panel {
  width: 72%;
  max-width: 320px;
  overflow: hidden;
  border-radius: 10px;
  background: #2b2b2b;
}
.bet-feedback-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 20px 24px;
  color: #fff;
}
.bet-feedback-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  margin-bottom: 16px;
}
.bet-feedback-icon.fail {
  border-radius: 50%;
  background: #f42c4c;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  font-style: italic;
  line-height: 1;
}
.bet-feedback-icon.success {
  color: #00e155;
}
.bet-feedback-icon.success svg {
  width: 54px;
  height: 54px;
}
.bet-feedback-body p {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
}
.bet-feedback-ok {
  width: 100%;
  height: 46px;
  border: 0;
  background: #f42c4c;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}
</style>
